document.addEventListener("DOMContentLoaded", () => {
  // Popup configurations for multiple sections
  const popupConfig = [
    { trigger: "manufactPopupTrigger", popup: "manufactPopup" },
    { trigger: "talkToUsPopupTrigger", popup: "talkToUsPopup" },
    { trigger: "deliveryTimePopupTrigger", popup: "deliveryTimePopup" },
    { trigger: "returnPolicyPopupTrigger", popup: "returnPolicyPopup" },
    { trigger: "needHelpPopupTrigger", popup: "needHelpPopup" },
  ];

  popupConfig.forEach(({ trigger, popup }) => {
    const triggerElement = document.getElementById(trigger);
    const popupElement = document.getElementById(popup);
    const closePopup = popupElement.querySelector(".close-popup");

    if (triggerElement && popupElement && closePopup) {
      // Open popup on trigger click
      triggerElement.addEventListener("click", () => {
        popupElement.style.display = "flex"; // Or use "block" depending on your styling needs
      });

      // Close popup on close button click
      closePopup.addEventListener("click", () => {
        popupElement.style.display = "none";
      });

      // Close popup when clicking outside the content
      window.addEventListener("click", (event) => {
        if (event.target === popupElement) {
          popupElement.style.display = "none";
        }
      });
    }
  });

  // Close the "Need Help" popup when clicking on the "Email" button
  const sendMailButton = document.querySelector(".send_mail");
  if (sendMailButton) {
    sendMailButton.addEventListener("click", () => {
      const needHelpPopup = document.getElementById("needHelpPopup");
      if (needHelpPopup) {
        needHelpPopup.style.display = "none"; // Close the Need Help popup
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const chatButtons = document.querySelectorAll(".do_chat");

  chatButtons.forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();

      // Get product URL and custom text from data attributes
      const prdurl = this.getAttribute("data-prdurl"); // Product URL from data attribute
      const texts = this.getAttribute("data-texts"); // Custom text from data attribute
      const phoneNumber = "919315036925"; // Replace with your WhatsApp number

      // Build the WhatsApp API URL
      const comp_url = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
        prdurl + " " + texts
      )}`;

      // Open the WhatsApp URL in a new tab
      window.open(comp_url, "_blank");
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const sendMailButton = document.querySelector(".send_mail");

  if (sendMailButton) {
    sendMailButton.addEventListener("click", () => {
      // Scroll to the #product-help section
      const offset = 130; // Offset for the scroll
      const productHelpElement = document.getElementById("product-help");
      if (productHelpElement) {
        const scrollPos = productHelpElement.offsetTop - offset;

        window.scrollTo({
          top: scrollPos,
          behavior: "smooth", // Smooth scrolling effect
        });
      }

      // Trigger a click on the collapsible form
      const collapsibleTrigger = document.querySelector(
        ".collapsible-trigger-form"
      );
      if (collapsibleTrigger) {
        collapsibleTrigger.click();
      }
    });
  }
});

// Popup JS Ends

document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector(".product-single__form");
  const notification = document.getElementById("cart-notification");

  if (form && notification) {
    form.addEventListener("submit", function (event) {
      event.preventDefault(); // Prevent default form submission

      // Show notification immediately
      notification.style.display = "grid";

      // Hide notification after 3 seconds
      setTimeout(() => {
        notification.style.display = "none";
      }, 3000);
    });
  }
});

document.querySelector("#sendemails").addEventListener("click", function () {
  // Add .is-open to collapsible trigger
  const collapsibleTrigger = document.querySelector(
    "#product-help .collapsible-trigger"
  );
  if (collapsibleTrigger) {
    collapsibleTrigger.classList.add("is-open");
    collapsibleTrigger.setAttribute("aria-expanded", "true");
  }

  // Add .is-open to collapsible content
  const collapsibleContent = document.querySelector(".thenew-collapsible");
  if (collapsibleContent) {
    collapsibleContent.classList.add("is-open");
    collapsibleContent.style.height = collapsibleContent.scrollHeight + "px"; // Calculate and apply height
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Check if any element with the .send_mail class exists
  const sendEmailsButton = document.querySelector(".send_mail");
  if (!sendEmailsButton) {
    console.error("The .send_mail button was not found in the DOM.");
    return;
  }

  const collapsibleContent = document.querySelector(".thenew-collapsible");
  if (!collapsibleContent) {
    console.error("The .thenew-collapsible element was not found in the DOM.");
    return;
  }

  // Add click event listener
  sendEmailsButton.addEventListener("click", function () {
    console.log("Send Emails button clicked!");
    collapsibleContent.classList.add("is-open");
    console.log("Class 'is-open' added to .thenew-collapsible.");
  });
});
